<mat-form-field [fxFlex]="fxFlex" appearance="outline" [style]="styles">
  <mat-label>{{ 'form.language' | translate }}</mat-label>
  <mat-select [ngModel]="currentLanguage" (ngModelChange)="updateLanguageProfile($event)">
    <mat-option *ngFor="let lang of languages" [value]="lang.value">
      {{ lang.title }}
    </mat-option>
  </mat-select>
</mat-form-field>
